<template>
<div class="iframe-resize-container" :style="{maxWidth}">
  <div class="iframe-content">
    <iframe ref="iframe" :src="attributes.value" frameborder="0" scrolling="no"></iframe>
    <div class="iframe-overlay"></div>
  </div>
</div>
</template>

<script>
/* globals iFrameResize */
import 'iframe-resizer/js/iframeResizer.min'

export default {
  props: ['attributes'],
  computed: {
    maxWidth () {
      const {maxwidth} = this.attributes
      return maxwidth || 'auto'
    }
  },
  mounted () {
    iFrameResize({}, this.$refs.iframe)
  }
}
</script>

<style lang="scss">
.component.component-iframeresize {
  padding: 0;
}

.iframe-resize-container {
  line-height: 0;
  position: relative;
  z-index: 50;

  .iframe-content {
    margin: 0 auto;
    position: relative;

    iframe {
      width: 1px;
      min-width: 100%;
    }

    .iframe-overlay {
      position: absolute;
      z-index: 50;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }
  }

  &:after {
      content: "";
      position: absolute;
      z-index: 100;
      top: 50%;
      left: 50%;
      width: 75px;
      height: 48px;
      background: url(~images/project/icons/icon_360_white.svg) no-repeat;
      filter: drop-shadow(2px 2px 3px $black);
      transform: translate(-50%, -50%);
      cursor: pointer;
  }

  &:hover {
      .iframe-overlay {
        background-color: rgba($black, 0);
      }
      &:after {
          content: none;
      }
  }
}
</style>
